import { NavLink, Route } from 'react-router-dom';

import styles from './FormToggles.style';

class FormToggles extends React.Component {
  toggleClassname = (match, options) => {
    const { classes } = this.props;
    const { borderLeft, borderRight } = options;
    return classnames(classes.formToggle, {
      [classes.formToggleActive]: !!match,
      [classes.formToggleBorderLeft]: !!borderLeft,
      [classes.formToggleBorderRight]: !!borderRight,
    });
  };

  render() {
    const { classes, form } = this.props;

    return (
      <div className={classes.formToggles}>
        <Route exact path={`/forms/${form.id}`}>
          {({ match }) => (
            <NavLink to={`/forms/${form.id}`}>
              <div
                className={this.toggleClassname(match, {
                  borderLeft: true,
                  borderRight: false,
                })}>
                Edit
              </div>
            </NavLink>
          )}
        </Route>

        <Route path={`/forms/${form.id}/preview`}>
          {({ match }) => (
            <NavLink to={`/forms/${form.id}/preview`}>
              <div
                className={this.toggleClassname(match, {
                  borderLeft: false,
                  borderRight: true,
                })}>
                Preview
              </div>
            </NavLink>
          )}
        </Route>
      </div>
    );
  }
}

export default withStyles(styles)(FormToggles);
